'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { PerformanceLabLeadFormSection } from '../PerformanceLabLeadFormSection';
import { IV_LOUNGE_CONSULT_ANCHOR_ID } from './ivLoungePageAssets';

export const IvLoungeLeadFormSection: React.FC = () => {
  const t = useTranslations('performance-lab');

  return (
    <PerformanceLabLeadFormSection
      id={IV_LOUNGE_CONSULT_ANCHOR_ID}
      heading={t('ivLounge.leadForm.heading')}
      ariaLabel={t('ivLounge.leadForm.aria')}
      submitButtonType="performance_lab_iv_lounge_lead_send"
      metaLeadContentName="iv_lounge_consult"
    />
  );
};
